import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors } from '../theme';

const VARIANTS = {
  default: { bg: colors.tealPale, fg: colors.teal },
  success: { bg: colors.successBg, fg: colors.success },
  warning: { bg: colors.warningBg, fg: colors.warning },
  danger:  { bg: colors.dangerBg, fg: colors.danger  },
  neutral: { bg: colors.hair,     fg: colors.inkSoft },
};

// Spec §8.2 — pill, height 14pt, padX 7pt, radius = h/2.
const Chip = ({ children, variant = 'default', style }) => {
  const v = VARIANTS[variant] || VARIANTS.default;
  return (
    <View style={[{
      backgroundColor: v.bg,
      paddingHorizontal: 7,
      height: 14,
      borderRadius: 7,
      alignSelf: 'flex-start',
      justifyContent: 'center',
    }, style]}>
      <Text style={[type.chip, { color: v.fg }]}>{children}</Text>
    </View>
  );
};

export default Chip;
